import React from "react";

const darkcolors = ["Red", "Black"]
export default function ComparisonSegment({ segment }) {
  return (
    <div className="segment comparisonSegment" style={{ backgroundColor: segment.segstyle?.bg.value, marginBottom: "50px" }}>
      <h2 style={{ color: darkcolors.includes(segment.segstyle?.bg.title) ? "#FFF" : "#000" }} className="text-center">{segment.title}</h2>
      <p style={{ color: darkcolors.includes(segment.segstyle?.bg.title) ? "#FFF" : "#000", fontSize: "1.3rem", maxWidth: "800px", margin: "0 auto 40px" }} className="text-center">{segment.description}</p>
      <table class="table table-striped comparison">
        <thead>
          <tr>
            <th scope="col">{segment.title}</th>
            <th scope="col">{segment.col1_label}</th>
            <th scope="col">{segment.col2_label}</th>
            <th scope="col">{segment.col3_label}</th>
          </tr>
        </thead>
        <tbody>
          {segment.comparison_item.map((item) => (
            <tr>
              <th scope="row">{item.title}</th>
              <td>{item.col1 ? <div className="bx bx-check"></div> : <div className="bx bx-x"></div>}</td>
              <td>{item.col2 ? <div className="bx bx-check"></div> : <div className="bx bx-x"></div>}</td>
              <td>{item.col3 ? <div className="bx bx-check"></div> : <div className="bx bx-x"></div>}</td>
            </tr>
          ))}

        </tbody>
      </table>
    </div>
  )
}